<template>
  <!-- Capture and consider -->
  <section class="capture has-text-centered">
    <h2 class="capture-title h1">
      {{ $t('page.whatIsLiffery.captureConsider.title') }}
    </h2>
    <h4 class="mt-2">
      {{ $t('page.whatIsLiffery.captureConsider.subTitle') }}
    </h4>
    <p class="capture-text">
      <span v-html="$t('page.whatIsLiffery.captureConsider.texts.1')"/><br/>
      <br/>
      <span v-html="$t('page.whatIsLiffery.captureConsider.texts.2')"/><br/>
      <br/>
      <b-collapse
        :open="false"
        position="is-bottom"
        aria-id="contentIdForA11y4">
        <template #trigger="props">
          <a
            class="colour-primary"
            aria-controls="contentIdForA11y4"
            :aria-expanded="props.open">
            <b>{{ !props.open ? $t('dict.readMore') : $t('dict.readLess') }}</b>
          </a>
        </template>

        {{ $t('page.whatIsLiffery.captureConsider.texts.3') }}<br/>
        <br/>

        {{ $t('page.whatIsLiffery.captureConsider.texts.4') }}<br/>
        <br/>
      </b-collapse>
    </p>
    <div class="capture-cards-wrapper">
      <!-- Cards -->
      <div class="capture-cards capture-cards-left">
        <!-- Card -->
        <o-capture-and-consider-channel-card
          v-for="(channel) in publicChannelsLH"
          :key="channel.slug"
          :channel="channel"
        />
      </div>

      <div class="capture-cards capture-cards-right">
        <!-- Card -->
        <o-capture-and-consider-channel-card
          v-for="(channel) in publicChannelsRH"
          :key="channel.slug"
          :channel="channel"
        />
      </div>
    </div>

    <button class="button is-primary lfr-button" @click="showMoreChannels">Load More</button>

    <div class="capture-line"></div>
    <div class="capture-ellipse-left"></div>
    <div class="capture-ellipse-right"></div>
  </section>
</template>

<style scoped lang="scss">
.capture {
  position: relative;
  padding-top: 7rem;
  padding-bottom: 7rem;
  color: $black;

  &-text {
    max-width: 52.95rem;
    margin: 2rem auto 4rem;
    line-height: 1.412rem;
    text-align: left;
    z-index: 5;
    position: inherit;
  }

  &-cards-wrapper {
    display: flex;
  }

  &-cards {
    position: relative;
    flex-grow: 1;
    margin-bottom: 4.235rem;
    z-index: 2;

    &-left {
      margin-right: 1.882rem;

      .channel-card {
        margin-left: auto;
      }
    }
  }

  .channel-card:not(:last-child) {
    margin-bottom: 1.412rem;
  }

  .lfr-button {
    z-index: 2;
  }

  &-ellipse-left,
  &-ellipse-right {
    position: absolute;
    z-index: 0;
    width: 12.4rem;
    height: 12.4rem;
    background: rgba($primary, .7);
    @include filterBlur(70px);
  }

  &-ellipse-left {
    pointer-events: none;
    left: 17%;
    top: 30%;
  }

  &-ellipse-right {
    right: 18%;
    bottom: 11%;
  }

  &-line {
    content: url("../../../../assets/landing-pages/new/line-up.svg");
    position: absolute;
    pointer-events: none;
    top: 4rem;
    left: 0;
    width: 100%;
    transform: rotate(20deg);
    z-index: 1;
  }

  @media screen and (max-width: $desktop) {
    &-title,
    &-text {
      position: relative;
      padding-right: 2rem;
      padding-left: 2rem;
    }

    &-cards {
      &-left {
        margin-right: 0;

        .channel-card {
          margin: auto;
        }
      }

      &-right {
        display: none;
      }
    }

    &-line {
      top: unset;
      bottom: 3rem;
    }
  }

  @media screen and (max-width: $tablet) {
    padding-top: 4rem;
    padding-bottom: 4rem;

    &-title {
      text-align: left;
    }

    &-text {
      margin: 1rem 0 2rem;
    }

    &-cards {
      margin: 0 1rem 2.824rem;
    }

    h4 {
      text-align: left;
      margin-left: 2rem;
    }

    .channel-card:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import PublicService from '@/api/ms-channel/services/PublicService';
import { Datum } from '@/api/ms-channel/services/interfaces/PublicChannels';
import AImage from '@/components/atoms/AImage.vue';
import { AuthenticationStore } from '@/store';
import getCssVar from '@/utils/getCssVar';
import OCaptureAndConsiderChannelCard from '@/components/organisms/landing/sections/OCaptureAndConsiderChannelCard.vue';

@Component({
  components: { OCaptureAndConsiderChannelCard, AImage }
})
export default class OCaptureAndConsider extends Vue {

  publicChannelsLH: Datum[] = [];
  publicChannelsRH: Datum[] = [];

  async created () {
    const { data } = await PublicService.publicChannelsGet({});
    data.forEach((item, i) => {
      if (i % 2 === 0) {
        this.publicChannelsLH.push(item);
      } else {
        this.publicChannelsRH.push(item);
      }
    });
  }

  showMoreChannels () {
    if (
      window.innerWidth < parseInt(getCssVar('--bp-desktop')) &&
      this.publicChannelsLH.length === 3
    ) {
      this.publicChannelsLH = this.publicChannelsLH.concat(this.publicChannelsRH);
    } else {
      this.loginPrompt();
    }
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_LOGIN({ state: true });
  }
}
</script>
